import React from "react";

const CampaignIcon = (props) => {
  return (
    <svg
      {...props}
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M10 29H26C26.5304 29 27.0391 28.7893 27.4142 28.4142C27.7893 28.0391 28 27.5304 28 27V11C28 10.4696 27.7893 9.96086 27.4142 9.58579C27.0391 9.21071 26.5304 9 26 9H14C13.4696 9 12.9609 9.21071 12.5858 9.58579C12.2107 9.96086 12 10.4696 12 11V27C12 27.5304 11.7893 28.0391 11.4142 28.4142C11.0391 28.7893 10.5304 29 10 29ZM10 29C9.46957 29 8.96086 28.7893 8.58579 28.4142C8.21071 28.0391 8 27.5304 8 27V18C8 17.4696 8.21071 16.9609 8.58579 16.5858C8.96086 16.2107 9.46957 16 10 16H12"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M23 13H17C16.4477 13 16 13.4477 16 14V16C16 16.5523 16.4477 17 17 17H23C23.5523 17 24 16.5523 24 16V14C24 13.4477 23.5523 13 23 13Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CampaignIcon;
